import { AfterViewInit,
  Component,
  Input } from '@angular/core';
import { Profile } from 'src/app/domain/cabinet/dto/Profile';
import { ERROR_IMAGE_LINK } from '../../../cabinet/component/cabinet/cabinet.component';
import {
  BROADCAST_CHANNEL_LOGOUT,
  BROADCAST_CHANNEL_LOGOUT_MESSAGE,
} from 'src/app/core/component/sidenav/side-nav.component';
import { AuthBackendService } from '../../../auth/service/auth-backend.service';
import { OrganizationAccesses } from 'src/app/domain/organization/components/service/organizations.service';
import { OrgUserManagementUrls } from '../../../org-user-management/module/org-user-mngmnt-routing';
import { SharedComponentsModule } from '../../../shared/module/shared-components.module';
import { AvatarIconComponent } from '../avatar-icon/avatar-icon.component';
import { fadeInOutAnimation } from "../../../../util/animations/fade-in-out.animation";
import { Router } from "@angular/router";
import {
  ModalExpiredSessionComponent,
} from "../../../../core/component/modal-expired-session/modal-expired-session.component";
import { DEFAULT_DROP_DOWN_DELAY_TIME, DelayService } from "../../../../core/service/delay.service";

@Component({
  selector: 'app-nav-avatar',
  templateUrl: './nav-avatar.component.html',
  styleUrl: './nav-avatar.component.scss',
  standalone: true,
  imports: [SharedComponentsModule, AvatarIconComponent, ModalExpiredSessionComponent],
  animations: [fadeInOutAnimation(200, 0)],
  providers: [DelayService],
})
/**
 * NavAvatarComponent is designed for use in {@link HorizontalNavBarComponent} and {@link EntranceComponent} where a user’s avatar
 * is accompanied by extra dropdown functionality. It provides a drop-down menu with actions such as:
 *
 * - Account settings
 * - Organization settings
 * - User management
 * - Support and log out options
 *
 * **Usage Guidelines:**
 * - **Dropdown interaction:** Use this component when you need the full set of
 *   interactive options (e.g. in hornavbar or entrance).
 * - **Simple Icon Display:** For cases where only the avatar image or initials are needed
 *   (without the extra functionality), please use the {@link AvatarIconComponent} instead.
 */
export class NavAvatarComponent implements AfterViewInit {
  @Input() showUserManagementOptions = false; // is needed to show user management tabs
  @Input() orgAccesses = new OrganizationAccesses(); // is needed to show user management tabs text, according to user accesses

  profile: Profile;
  name = '';
  errorImageLink = ERROR_IMAGE_LINK;
  showAvatarMenu = false;
  // when user makes log out it sends signal to another tabs to synchronize log out for all tabs where user was working
  broadcasterLogOut = new BroadcastChannel(BROADCAST_CHANNEL_LOGOUT);
  showExpiredSessionModal = false;

  protected readonly OrgUserManagementUrls = OrgUserManagementUrls;

  constructor(
    private authService: AuthBackendService,
    private delayService: DelayService,
    private router: Router,
  ) {
  }

  ngAfterViewInit(): void {
    this.delayService.initSubscribes(DEFAULT_DROP_DOWN_DELAY_TIME,
      () => {
        this.showAvatarMenu = true;
      },
      () => {
        this.showAvatarMenu = false;
      });
  }

  activateAvatarMenu(): void {
    this.delayService.activate();
  }

  deactivateAvatarMenu(): void {
    this.delayService.deactivate();
  }

  /** Method used for triggering the functionality of the `broadcasterLogOut`'s subscribers */
  async logout(): Promise<void> {
    await this.authService.logout();
    this.broadcasterLogOut.postMessage(BROADCAST_CHANNEL_LOGOUT_MESSAGE);
  }

  mailToSupport(): void {
    window.location.href = 'mailto:helpdesk@orcainc.com?subject=Support Request';
  }

  async goToLogin(): Promise<void> {
    await this.router.navigate(['/login']);
    this.showExpiredSessionModal = false;
  }
}


